"use client"

import { ArrowRight02Icon } from "@hugeicons/core-free-icons"
import { HugeiconsIcon } from "@hugeicons/react"
import { motion } from "framer-motion"
import { AnimatedCTALink } from "@/components/ui/animated-cta-link"

export default function CTASectionMinimal() {
    return (
        <section className="container mx-auto px-4 py-24 md:py-44">
            <div className="border-border/70 border-t pt-12 md:pt-16 dark:border-border/40">
                <div className="grid grid-cols-1 gap-12 lg:grid-cols-12">
                    {/* Section Header */}
                    <div className="text-center lg:col-span-3 lg:text-left">
                        <span className="font-mono text-muted-foreground text-xs uppercase tracking-widest">
                            Get in touch
                        </span>
                    </div>

                    {/* Content */}
                    <div className="flex flex-col items-center gap-8 text-center lg:col-span-9 lg:items-start lg:text-left">
                        <motion.h2
                            initial={{ opacity: 0, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.5 }}
                            viewport={{ once: true }}
                            className="max-w-4xl font-medium text-5xl text-muted-foreground tracking-tighter sm:text-7xl md:text-8xl"
                        >
                            Want to build something{" "}
                            <br className="hidden sm:block" />
                            <span className="text-foreground">
                                meaningful together?
                            </span>
                        </motion.h2>

                        <motion.p
                            initial={{ opacity: 0, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.5, delay: 0.1 }}
                            viewport={{ once: true }}
                            className="max-w-xl text-lg text-muted-foreground sm:text-xl"
                        >
                            I like turning hard problems into products people
                            actually want to use. If that sounds like your
                            project, let&apos;s talk.
                        </motion.p>

                        <motion.div
                            initial={{ opacity: 0, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.5, delay: 0.2 }}
                            viewport={{ once: true }}
                            className="pt-4"
                        >
                            <AnimatedCTALink
                                href="https://www.linkedin.com/in/phalla-doll-60563a1b9/"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                Connect on LinkedIn
                                <HugeiconsIcon
                                    icon={ArrowRight02Icon}
                                    className="ml-2 size-5 transition-transform group-hover:translate-x-1"
                                    strokeWidth={1.5}
                                />
                            </AnimatedCTALink>
                        </motion.div>
                    </div>
                </div>
            </div>
        </section>
    )
}
